module.exports = __webpack_public_path__ + "img/pr_2.3b12cdc4.png";